import React, { useCallback, useState } from 'react';
import AppTokenHandler from '@parcel2go/npm-app-react-authentication/dist/appTokenHandler';
import { IP2GProfile } from '@parcel2go/peacock-legacy-profile';
import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import Loading from './components/Loading';
import { IP2GP2GMyAccountSearch } from '@parcel2go/legacy-my-account-core/dist/search';
import AppLayout from './AppLayout';

export interface SearchConfigType extends IP2GP2GMyAccountSearch {
  searchEnabled: boolean;
}

const P2GApp = React.lazy(() =>
  import('@parcel2go/peacock-legacy-app/dist/contextProvider').then((module) => ({ default: module.P2GApp })),
);

const App: React.FC = () => {
  const [appChecked, setAppChecked] = React.useState<boolean>(false);
  const [profileId, setProfileId] = useState<string>(null);
  const [isAppSignin, setIsAppSignin] = React.useState<boolean>(false);

  const onAppCheckComplete = async (appToken: string) => {
    if (appToken) {
      setIsAppSignin(true);
    }
    setAppChecked(true);
  };

  const isLocalDev: boolean = process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost';
  const devProf = { id: 'PARCEL2GO.UK.DEVELOPMENT', authority: 'https://parcel2go.test.p2g.ninja/auth' } as IP2GProfile;

  const onProfileLoaded = useCallback((x: IP2GProfile) => {
    setProfileId(x.id);
  }, []);

  return (
    <AppTokenHandler onComplete={onAppCheckComplete}>
      {appChecked && (
        <P2GApp
          profile={isLocalDev ? devProf : null}
          socket
          requiresAuthentication={!isAppSignin}
          onLoadedProfile={onProfileLoaded}>
          <P2GBox backgroundColour="white">
            {profileId ? <AppLayout isAppSignin={isAppSignin} profileId={profileId} /> : <Loading />}
          </P2GBox>
        </P2GApp>
      )}
    </AppTokenHandler>
  );
};

export default App;
